// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchFilters-cls1_lcv","cls2":"SearchFilters-cls2_NiW SearchFilters-cls1_lcv"};